/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Orders {
  dateCreated?: Date;
  dateUpdated?: Date;
  descriptionBot?: string;
  finalDeliveryDate?: Date;
  npedidoCliente?: string;
  ordersId?: number;
  pedidoV?: string;
  shippingOrderId?: number;
  shippingOrderItemId?: number;
  statusOrderDescription?: string;
}
